import { render, staticRenderFns } from "./OsixSelection.vue?vue&type=template&id=18480fd6&scoped=true&"
import script from "./OsixSelection.vue?vue&type=script&lang=ts&"
export * from "./OsixSelection.vue?vue&type=script&lang=ts&"
import style0 from "./OsixSelection.vue?vue&type=style&index=0&id=18480fd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18480fd6",
  null
  
)

export default component.exports